"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _excluded = ["classNames"];

/**
 * @deprecated use `import LazyImage from @insided/shared/uikit/LazyImage`
 */
var LazyLoader = function LazyLoader(_ref) {
  var classNames = _ref.classNames,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)(_LazyImage.default, (0, _extends2.default)({
    className: classNames
  }, restProps));
};
/**
 * @deprecated use `import LazyImage from @insided/shared/uikit/LazyImage`
 */


var _default = LazyLoader;
exports.default = _default;